import React, { useState } from "react";
import { ReactComponent as DropdownIcon } from "../../assets/images/DropdownIcon.svg";

const CustomAccordion = ({ defaultOpen, label, children, width, height, darkBG }) => {
  const [open, setOpen] = useState(defaultOpen);

  const toggleAccordion = () => {
    setOpen(!open);
  };

  return (
    <div className="accordion-container col-span-2  ">
      <div
        className="accordion-label cursor-pointer  border-t border-b border-gray-300 flex flex-col justify-centre items-start"
        style={{ width, height }}
      >
        <div
          className={`flex items-center justify-between w-full  px-3 py-4 ${darkBG ? "bg-[#e9edf0]" : "bg-[#FAFAFA]"}  shadow-md sticky top-0 z-[1]`}
          onClick={toggleAccordion}
        >
          <span className={`text-[#1D4469] ${darkBG ? "text-base font-600" : "font-500"} font-poppins `}>{label}</span>
          <span className={`transform transition-transform duration-300 ${open ? "rotate-180" : ""}`}>
            <DropdownIcon />
          </span>
        </div>

        {open && (
          <div
            className={`accordion-content py-2 px-3 border-b border-gray-300  transition-all duration-100 ease-in-out overflow-y-auto thinscrollbar w-full`}
            // style={{ maxHeight: height, width }}
          >
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomAccordion;
